import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoWaterHeater } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoWaterHeater} />; }
